export const getExtensionFile = ({ name }) => {
  return name.substring(name.lastIndexOf(".") + 1).toLowerCase();
};
